import { IsProduction } from "./util/Environment";
import ConfigService from './services/config/config.service';

function sleep(seconds: number): Promise<void> {
    return new Promise(res => setTimeout(res, seconds * 1000));
}

export async function LoadStaticScripts(history: any) {
    await sleep(4);

    if (IsProduction()) {

        const ReactGA = await import("react-ga");
        const Hotjar = (await import("react-hotjar")).hotjar;

        ReactGA.initialize(`${ConfigService.getConfig().miscellaneousConfig.gATracking}`);
        Hotjar.initialize(ConfigService.getConfig().miscellaneousConfig.hotjarId, ConfigService.getConfig().miscellaneousConfig.hotjarSV);

        history.listen((location, action) => {
            ReactGA.set({ page: location.pathname });
            ReactGA.pageview(location.pathname);
            window.scrollTo(0, 0);
        });

    }
}


// WEBPACK FOOTER //
// ./src/StaticScripts.ts